<script setup lang="ts">
import { extendNativePrototypes } from '~~/src/layers/toolkit/native';

// SSR is extended in server/plugins/native.
if (import.meta.client) {
  extendNativePrototypes();
}

// INFO: required to avoid hydration issues
//
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
provideHeadlessUseId(() => useId());
</script>

<template>
  <NuxtRouteAnnouncer />
  <Root />
</template>
